/* Petask kart satın alma (Instacart chip + Walmart/Amazon stepper):
   - fiyatlı gramaj chip'leri; seçim, sayaç ve görseli o varyanta çevirir
   - "Sepete Ekle" → eklenince yeşil "− n +" çubuğuna dönüşür
   - − karttan azaltır (1'den 0'a inince ürün sepetten çıkar, buton geri gelir)
   - sayfa açılışında sepetteki adetler kartlara yansır */
(function () {
  if (window.__petaskVarbox) return;
  window.__petaskVarbox = true;

  var CART = { items: [] };
  var CART_YUKLENDI = false;

  function getData(box) {
    try { return JSON.parse(box.querySelector('[data-petask-variants]').textContent); }
    catch (e) { return []; }
  }
  function selectedVariant(box) {
    var a = box.querySelector('.petask-chip.active');
    var idx = a ? +a.dataset.idx : 0;
    return getData(box)[idx];
  }
  function qtyOf(variantId) {
    var q = 0;
    (CART.items || []).forEach(function (it) { if (it.variant_id === variantId) q += it.quantity; });
    return q;
  }
  function renderBox(box) {
    var v = selectedVariant(box);
    if (!v) return;
    var q = qtyOf(v.id);
    var atc = box.querySelector('[data-petask-atc]');
    var st = box.querySelector('[data-petask-stepper]');
    var ap = box.querySelector('[data-petask-atc-price]');
    if (ap) ap.textContent = '· ' + v.price;
    if (q > 0) {
      atc.hidden = true;
      st.hidden = false;
      var inCartWord = (window.PETASK_CARDS && window.PETASK_CARDS.inCart) || 'sepette';
      box.querySelector('[data-petask-count]').textContent = q + ' ' + inCartWord;
    } else {
      st.hidden = true;
      atc.hidden = false;
      atc.disabled = !v.available;
    }
  }
  function renderAll() {
    document.querySelectorAll('[data-petask-varbox]').forEach(renderBox);
  }
  function announce(cart, variantId) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'petask-varbox',
        /* 🔴 source ASLA 'product-form-component' OLMAMALI.
           Horizon (cart-icon.js:74) o kaynağı gördüğünde itemCount'u mevcut sayıya
           EKLER: `comingFromProductForm ? currentCartCount + itemCount : itemCount`.
           Biz ise sepetin TOPLAMINI gönderiyoruz → her ekleme rozeti şişiriyordu
           (3 ürünlük sepette rozet 5 görünüyordu, 2026-08-05'te kullanıcı bildirdi).
           Farklı bir kaynak adıyla Horizon sayıyı EKLEMEZ, SET eder. */
        data: { source: 'petask-varbox-add', itemCount: cart.item_count, variantId: String(variantId) },
      },
    }));
  }
  async function refreshCart() {
    CART = await (await fetch('/cart.js')).json();
    CART_YUKLENDI = true;
    return CART;
  }
  async function setQty(box, variantId, qty) {
    var zone = box.querySelector('[data-petask-qtyzone]');
    zone.classList.add('is-loading');

    /* Standart storefront olayi: app'ler ve yapay zeka ajanlari sepet
       degisikligini tema DOM'unu ayristirmadan gorebilsin diye yayilir.
       Kutuphane yuklenmemisse sessizce atlanir — sepet islevi buna bagli DEGIL.
       Dokumantasyon: olay ASENKRON islem BASLAMADAN once yayilir, sonuc
       ertelenmis promise ile cozulur (dinleyiciler yukleniyor durumu gosterebilsin). */
    var SE = window.petaskStandardEvents;
    var oncekiAdet = qtyOf(variantId);
    var deferred = null;
    if (SE && SE.CartLinesUpdateEvent) {
      try {
        deferred = SE.CartLinesUpdateEvent.createPromise();
        box.dispatchEvent(new SE.CartLinesUpdateEvent({
          action: qty === 0 ? 'remove' : qty > oncekiAdet ? 'add' : 'update',
          context: 'product',
          lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: qty }],
          promise: deferred.promise,
        }));
      } catch (e) { deferred = null; }
    }

    try {
      var updates = {};
      updates[variantId] = qty;
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      if (!res.ok) throw new Error('update failed');
      CART = await res.json();
      if (deferred) {
        deferred.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(CART) });
      }
      announce(CART, variantId);
      renderAll();
    } catch (err) {
      /* Cozulmemis promise dinleyicileri sonsuza kadar bekletir — daima
         reject et ve hatayi standart olarak da duyur. */
      if (deferred) deferred.reject(err);
      if (SE && SE.CartErrorEvent) {
        try {
          box.dispatchEvent(new SE.CartErrorEvent({
            error: String(err && err.message ? err.message : err),
            code: 'SERVICE_UNAVAILABLE',
          }));
        } catch (e) { /* yut */ }
      }
      var atc = box.querySelector('[data-petask-atc]');
      atc.classList.add('is-error');
      setTimeout(function () { atc.classList.remove('is-error'); }, 1500);
    } finally {
      zone.classList.remove('is-loading');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Sayfada hiç kart yoksa /cart.js isteğini hiç yapma — gereksiz ağ trafiği.
     Kartlar sonradan enjekte edilirse aşağıdaki MutationObserver tetikliyor. */
  function init() {
    if (!document.querySelector('[data-petask-varbox]')) return;
    refreshCart().then(renderAll).catch(function () {});
  }

  /* sonradan enjekte edilen kartlar (ör. "Bunları da beğenebilirsiniz") gelince tazele */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && n.matches('[data-petask-varbox]') || n.querySelector && n.querySelector('[data-petask-varbox]'))) {
          /* İlk kart sonradan geldiyse sepet henüz çekilmemiş olabilir */
          if (!CART_YUKLENDI) { refreshCart().then(renderAll).catch(function () {}); }
          else { renderAll(); }
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* baska bir bilesen sepeti degistirirse (ör. sepet çekmecesi) kartlari tazele */
  document.addEventListener('cart:update', function (e) {
    var src = e.detail && e.detail.sourceId;
    if (src === 'petask-varbox' || src === 'petask-bfcache') return;
    refreshCart().then(renderAll).catch(function () {});
  });

  /* 🔴 GERİ TUŞU (bfcache) DÜZELTMESİ — 2026-08-05
     Tarayıcı geri/ileri ile dönüldüğünde sayfa YENİDEN YÜKLENMEZ; DOMContentLoaded
     çalışmaz, dolayısıyla init() de çalışmaz ve ekrandaki sepet durumu donmuş kalır.
     Senaryo: anasayfa sepet BOŞKEN açılır → başka sayfada ürün eklenir → ödemeye
     gidilir → geri basılır → anasayfa boş sepetli hâliyle geri gelir (rozet yok,
     kartlarda "sepette" yok) ama sepette ürün VARDIR.

     Horizon'un cart-icon.js'i bunu düzeltmeye çalışıyor ama sessionStorage'daki
     sayıya **10 saniyelik tazelik şartı** koyuyor (`Date.now() - timestamp < 10000`);
     ödeme sayfasında 10 saniyeden fazla kalan herkeste düzeltme atlanıyor.

     Bu yüzden sepeti sunucudan tazeleyip hem kartları hem de rozeti güncelliyoruz.
     Rozet için cart-icon'un dinlediği `cart:update` olayını yayınlıyoruz; kaynak
     'product-form-component' OLMADIĞI için sayıyı ekler değil, SET eder. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    refreshCart()
      .then(function () {
        renderAll();
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: CART,
              sourceId: 'petask-bfcache',
              data: { source: 'bfcache-restore', itemCount: CART.item_count },
            },
          })
        );
      })
      .catch(function () {});
  });

  document.addEventListener(
    'click',
    async function (e) {
      /* chip secimi */
      var chip = e.target.closest('.petask-chip');
      if (chip) {
        e.preventDefault();
        e.stopPropagation();
        var box = chip.closest('[data-petask-varbox]');
        box.querySelectorAll('.petask-chip').forEach(function (c) { c.classList.remove('active'); });
        chip.classList.add('active');
        var v = selectedVariant(box);
        if (v && v.image) {
          var card = box.closest('.product-card, product-card, li, .card') || box.parentElement;
          var img = card ? card.querySelector('img') : null;
          if (img) {
            /* Responsive srcset/sizes yüzünden yalnız src'yi değiştirmek yetmez —
               tarayıcı hâlâ eski aday görseli gösterebiliyordu. Tek-aday srcset
               vererek sizes'tan bağımsız bu görseli garantiye al. */
            img.setAttribute('src', v.image);
            img.setAttribute('srcset', v.image);
            img.removeAttribute('sizes');
            var pic = img.closest('picture');
            if (pic) {
              pic.querySelectorAll('source').forEach(function (s) { s.setAttribute('srcset', v.image); });
            }
          }
        }
        renderBox(box);
        return;
      }

      /* sepete ekle */
      var atc = e.target.closest('[data-petask-atc]');
      if (atc && !atc.disabled) {
        e.preventDefault();
        e.stopPropagation();
        var box2 = atc.closest('[data-petask-varbox]');
        var v2 = selectedVariant(box2);
        if (v2) await setQty(box2, v2.id, qtyOf(v2.id) + 1);
        return;
      }

      /* stepper + / − */
      var plus = e.target.closest('[data-petask-plus]');
      var minus = e.target.closest('[data-petask-minus]');
      if (plus || minus) {
        e.preventDefault();
        e.stopPropagation();
        var box3 = (plus || minus).closest('[data-petask-varbox]');
        var v3 = selectedVariant(box3);
        if (!v3) return;
        var q = qtyOf(v3.id) + (plus ? 1 : -1);
        if (q < 0) q = 0;
        await setQty(box3, v3.id, q);
      }
    },
    true
  );
})();
